export const DeviceModeEnum = {
    Desktop: 0,
    Mobile: 1,
    Tablet: 2
}

Object.freeze(DeviceModeEnum);

export default DeviceModeEnum;